import { Component,  OnInit, OnDestroy } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PhBhpObservationProtocolFeedbackComponent } from '../ph-bhp-observation-protocol-feedback/ph-bhp-observation-protocol-feedback.component';
import { PHBHPFeaturePackageObserveObservationService } from '../ph-bhp-feature-package-observe-observation.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Subscription } from 'rxjs'
import { DatePipe } from '@angular/common';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-observe-observation-protocol',
  templateUrl: './ph-bhp-observe-observation-protocol.component.html',
  styleUrls: ['./ph-bhp-observe-observation-protocol.component.css'],
  providers: [DatePipe]
})
export class PhBhpObserveObservationProtocolComponent implements OnInit, OnDestroy {

  userData;
  searchText: string;
  flagInit = true;
  timeflag;
  timeLine = [];
  subscription :Subscription;
  userSubscription:Subscription;
  langSubscription:Subscription;
  sessionList:Array<any>;
  tempSessionList:Array<any>;
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(
    private modalService: BsModalService,
    private datePipe: DatePipe,
    private service: PHBHPFeaturePackageObserveObservationService,
    public layoutService: PHBHPLayoutPackageService,
    public appConfig: AppConfig
    ) { }

  ngOnInit(){
    if(this.appConfig.userData){
      this.userData = this.appConfig.userData;
      this.onInitUser();
    }
    this.userSubscription = this.appConfig.userSubject.asObservable().subscribe(res=>{
      if(this.flagInit){
        this.flagInit = false;
        this.userData = this.appConfig.userData;
        this.onInitUser();
      }
    })

    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.reSetTime();
      this.setTimeLine(this.sessionList);
    })
  }

  onInitUser(){
    var userId = this.userData.userId;
    var roleId =  this.userData.roleName.roleId
    if(this.layoutService.institutionID){
      this.setUserSession(userId, roleId)
    }
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe(res=>{
      this.setUserSession(userId, roleId)
    })
  }
  reSetTime(){
    this.timeflag = '';
    this.timeLine = [];
  }
  openProtocolDetails(index) {
    var session = this.sessionList[index];
    var initialState = {
      sessionId :session.observationSessionID,
      userId: this.userData.userId,
      institutionId: this.layoutService.institutionID,
      countryId: this.userData.country
    }
    this.modalService.show(PhBhpObservationProtocolFeedbackComponent,{initialState, class: 'modal-full w-full'});
  }

  setUserSession(userId, roleId){
    this.layoutService.showLoader= true;
    this.service.getUserSession(userId, this.layoutService.institutionID, roleId).subscribe(res=>{
      this.layoutService.showLoader= false;
      this.sessionList = res;
      this.tempSessionList = res;
      this.setTimeLine(this.sessionList);
    })
  }

  searchTextChange(){
    this.sessionList = this.tempSessionList.filter(word => word.departmentName.toLowerCase().includes(this.searchText.toLowerCase()) || word.wardName.toLowerCase().includes(this.searchText.toLowerCase()));
    this.setTimeLine(this.sessionList);
  }

  setTimeLine(sessionList){
    this.timeLine= [];
    sessionList.forEach((value, index) => {

      var timeflag = value.startDateTime.split("T")[0];
      var timeData = {} as any
      if (!value.endDateTime) {
        timeData.inProgress = true;
      }

      if (this.timeflag == timeflag) {
        timeData.date = false
      } else {
        this.timeflag = timeflag;
        timeData.date = "";

        if (index == 0) {
          var date = new Date();
          var dateFlag = date.toISOString().split("T")[0]
          if (dateFlag == timeflag) {
            //timeData.date = this.data.translatetext(this.translationKeys.Dashboard.Today)+', ';
            timeData.isToday = true;
          }
        }
        var lang = localStorage.getItem('selectedlanguage') || 'en';
        var newDate = this.layoutService.convertUTCStingToLocalDate(value.startDateTime);
        var latest_date =  newDate.toLocaleDateString(lang, { weekday: 'long', month: "long", day: "numeric", year: "numeric" });
        timeData.date += latest_date;
      }
      timeData.startDateTime = this.timeFormat(this.layoutService.convertUTCStingToLocalDate(value.startDateTime));
      timeData.endDateTime = this.timeFormat( this.layoutService.convertUTCStingToLocalDate(value.endDateTime));
      this.timeLine.push(timeData);
    })
  }

  ngOnDestroy() {
    if(this.subscription) {
      this.subscription.unsubscribe()
    }
    if(this.userSubscription) {
      this.userSubscription.unsubscribe()
    }
    if(this.langSubscription){
      this.langSubscription.unsubscribe()
    }
  }

  dateFormat(date) {
    const newDate = this.layoutService.convertUTCStingToLocalDate(date);
    let lang = localStorage.getItem('selectedlanguage');
    lang = lang ? (lang == 'null' ? 'en': lang) : 'en';
    return newDate.toLocaleDateString(lang, { weekday: 'long', month: "long", day: "numeric", year: "numeric" });
  }

  timeFormat(time) {
    let lang = localStorage.getItem('selectedlanguage');
    lang = lang ? (lang == 'null' ? 'en': lang) : 'en';
    return time.toLocaleTimeString(lang, { hour12: false, hour: '2-digit', minute: '2-digit' });
  }

  onSearchTextChanged(text: string): void {
    this.searchText = text;
    this.searchTextChange();
  }

}
